/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel
     */
    isVisiable?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'isVisiable': !exists(json, 'isVisiable') ? undefined : json['isVisiable'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'isVisiable': value.isVisiable,
    };
}

